import React from "react";
import nodata from "../../assets/images/no-data.png";

function PrescriptionDataListing({ responseData }) {
  const result = responseData?.result || {};
  // Recursive function to flatten nested objects
  const renderData = (data) => {
    return Object.entries(data).map(([key, value]) => {
      if (typeof value === "object" && value !== null) {
        // Nested section
        return (
          <div key={key} className="col-12 mb-1">
            <h5 className="font_15 fw-bold text_master2 mt-2 mb-2">{key}</h5>
            <div className="row ps-3">{renderData(value)}</div>
          </div>
        );
      } else {
        // Normal key-value
        return (
          <div key={key} className="col-12 py-2 document_values pb-0 pb-sm-2">
            <div className="row">
              <div className="col-12 font_500 col-md-6 text_gray8 text-capitalize">
                {key}
              </div>
              <div className="col-12 col-md-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                <div className="d-flex justify-content-start">
                  <span className="text_master2 fw_600 word_break text-start">
                    {value || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const hasData = result && Object.keys(result).length > 0;
  return (
    <div className="extracted_data_section pb-3 overflow-auto scrollbar1 px-0 px-md-3 px-md-0 position-relative">
      <div className="pt-3 pt-md-0">
        <h2 className="font_16 fw-bold mb-3 text-center pt-2 mb-2">
          Extracted Data
        </h2>
      </div>

      {hasData ? (
        <div className="px-3 pt-3 pb-1 font_13">
          <div className="row">{renderData(result)}</div>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
          <img
            src={nodata}
            className="no_data_thumbnail object_fit_contain"
            alt="No Data"
          />
          <h4 className="text_gray7 font_16 mt-3">Unable To Process Data</h4>
        </div>
      )}
    </div>
  );
}

export default PrescriptionDataListing;
